import { __rest } from 'tslib';
import { jsxs, jsx } from 'react/jsx-runtime';
import classNames from 'classnames';

var SunHighIcon = function SunHighIcon(_a) {
  var className = _a.className,
    otherProps = __rest(_a, ["className"]);
  return jsxs("svg", Object.assign({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-label": "SunHighIcon",
    role: "img",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    fill: "none",
    className: classNames('cogs-icon', className)
  }, otherProps, {
    children: [jsx("g", {
      fill: "currentColor",
      fillRule: "evenodd",
      clipPath: "url(#clip0_1218_59044)",
      clipRule: "evenodd",
      children: jsx("path", {
        d: "M8.003 4.576a3.391 3.391 0 1 1 .06 6.782 3.391 3.391 0 0 1-.06-6.782m.765 1.594a1.942 1.942 0 1 0-1.47 3.594 1.942 1.942 0 0 0 1.47-3.594M4.741 11.259a.725.725 0 0 1 0 1.025l-.942.943A.725.725 0 0 1 2.773 12.2l.943-.942a.725.725 0 0 1 1.025 0M2.773 2.773a.725.725 0 0 1 1.026 0l.942.943a.725.725 0 1 1-1.025 1.025L2.773 3.8a.725.725 0 0 1 0-1.026M13.227 2.773a.725.725 0 0 1 0 1.026l-.943.942a.725.725 0 1 1-1.025-1.025l.942-.943a.725.725 0 0 1 1.026 0M11.259 11.259a.725.725 0 0 1 1.025 0l.943.942a.725.725 0 0 1-1.026 1.026l-.942-.943a.725.725 0 0 1 0-1.025M.608 8c0-.4.325-.725.725-.725h1.334a.725.725 0 0 1 0 1.45H1.333A.725.725 0 0 1 .608 8M8 .608c.4 0 .725.325.725.725v1.334a.725.725 0 0 1-1.45 0V1.333c0-.4.325-.725.725-.725M12.608 8c0-.4.325-.725.725-.725h1.334a.725.725 0 0 1 0 1.45h-1.334A.725.725 0 0 1 12.608 8M8 12.608c.4 0 .725.325.725.725v1.334a.725.725 0 0 1-1.45 0v-1.334c0-.4.325-.725.725-.725"
      })
    }), jsx("defs", {
      children: jsx("clipPath", {
        id: "clip0_1218_59044",
        children: jsx("path", {
          fill: "#fff",
          d: "M0 0h16v16H0z"
        })
      })
    })]
  }));
};

export { SunHighIcon };
